import is from "is_js";
export var isSupportedBrowser = function () {
    return is.firefox(">= 62")
        || is.edge(">= 18")
        || is.chrome(">= 79")
        || is.safari(">= 11")
        || is.iphone(">= 7")
        || is.ipad(">= 7")
        || is.ie(">= 11");
};
